import React from 'react';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';

export interface WindowHeaderProps {
  title: React.ReactNode;
  onClose?: (event?: React.MouseEvent) => void;
  /** Acción opcional a la derecha (p. ej. editar grupo cuando hay empresa seleccionada) */
  onEditGrupo?: () => void;
}

const WindowHeader = ({ title, onClose, onEditGrupo }: WindowHeaderProps) => {
  return (
    <div className="col-12 col-md-12">
      <div
        className="d-flex align-items-center justify-content-between gap-2 bg-primary text-white p-3"
        style={{ minHeight: 52 }}
      >
        <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: 88 }}>
          {onClose ? (
            <button type="button" className="btn btn-sm btn-light" onClick={e => onClose(e)}>
              Cerrar
            </button>
          ) : (
            <span aria-hidden style={{ width: 1 }} />
          )}
        </div>
        <h5 className="m-0 text-center flex-grow-1 text-white px-2" style={{ lineHeight: 1.3 }}>
          {title}
        </h5>
        <div
          className="d-flex align-items-center justify-content-end flex-shrink-0"
          style={{ minWidth: 88 }}
        >
          {onEditGrupo ? (
            <button
              type="button"
              className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
              style={{ width: 36, height: 32, padding: 0 }}
              onClick={onEditGrupo}
              aria-label="Editar grupo"
              title="Editar grupo"
            >
              <FaPencilAlt />
            </button>
          ) : (
            <span aria-hidden style={{ width: 1 }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default WindowHeader;
